// extracted by mini-css-extract-plugin
export default {"name":"_39ZXDFvt6Yft0RrrWzgQ4g","capacity":"_2FpcdCjzn4nVc1PdnPrtiq","pricing":"_4u3Scp8tmwjkqcaiyoDXPJ"};